module.exports = __webpack_public_path__ + "img/139.fafad999.jpg";